import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { IonPage, IonHeader, IonContent, IonButton, IonFooter } from '@ionic/react'
import { Icon, Input } from '@cps'
import { loadingLayer, useHistoryNew } from '@utils'
import thirdPartyMobx, { TThirdType } from '@mobx/pay/thirdParty.mobx'
import { classNames, uuid } from '@dt/fe-utils'
import { CouponItem as ThirdCouponItem } from './components'

import './index.scss'
import MktController from '@ctrls/mktController'
interface IProps {
  match: any;
}

// 券类型
const thirdTypes = Object.keys(TThirdType)

const ThirdCoupon: React.FC<IProps> = props => {
  const history = useHistoryNew()
  const initType = props.match?.params?.type || TThirdType.douyin
  const [selectType, setSelectType] = useState<TThirdType>(initType)
  const [code, setCode] = useState('')
  const [showTips, setShowTips] = useState(true)
  const { couponList } = thirdPartyMobx

  const hasCoupon = !!couponList.length

  const handleBack = () => {
    try {
      !history.getPrevState() ? history.replace('/menu') : history.goBack()
    } catch (error) { }
  }

  const handleGetCoupon = async () => {
    loadingLayer.show()
    try {
      const coupon = await thirdPartyMobx.getCouponDetail({ type: selectType, couponCode: code })
      if (coupon) {
        thirdPartyMobx.checkCoupon({ ...coupon })
        setCode('')
      }
    } catch (error) {
    }
    loadingLayer.hide()
  }

  const handleSelectType = (type: TThirdType) => {
    setSelectType(type)
  }

  useEffect(() => {
    // 101908075670882,101058642307842
  }, [])
  return (
    <IonPage className='third-coupon-page'>
      <IonHeader>
        <div className='close-btn' data-cypid='close-third-coupon' onClick={handleBack}>
          <Icon name='close' />
        </div>
      </IonHeader>
      <IonContent className='third-coupon-content'>
        <div className={classNames('third-coupon-content-wrapper', { 'has-use': hasCoupon })}>
          <div className='type-tab-content'>
            {
              thirdTypes.map((item: TThirdType, index) => (
                <div
                  className={classNames(`type-tab-btn ${item}`, { select: selectType === item })}
                  key={uuid()}
                  data-cypid={`third-coupon-type-${item}`}
                  onClick={() => handleSelectType(item)}
                >
                  <Icon name={item} />
                </div>
              ))
            }
          </div>
          <div className='code-input-wrapper'>
            <Input
              value={code}
              className='code-input'
              placeholder={i18n.t('menu.inputCouponCode')}
              data-cypid='input-third-coupon'
              onInput={(event) => {
                setCode(event.target.value)
                showTips && setShowTips(false)
              }}
            />
            <IonButton disabled={!code} className='code-btn' data-cypid='btn-third-coupon' onClick={handleGetCoupon}>{i18n.t('common.use')}</IonButton>
            {
              showTips && !hasCoupon && (
                <div className='input-foucs-wrapper'>
                  <div className='arrow'>👆</div>
                  <p className='black'>{i18n.t('menu.inputCouponCodeTips1')}</p>
                  <p>{i18n.t('menu.inputCouponCodeTips2')}</p>
                </div>
              )
            }
          </div>
          {hasCoupon && <div className='split-line'>{i18n.t('menu.usingThirdCoupon')}</div>}
          <div className='third-coupon-details-wrapper'>
            {
              couponList.map((item, index) => (
                <div key={index}>
                  <ThirdCouponItem
                    selected={!!thirdPartyMobx.checkCouponsMap[item.couponCode]}
                    couponInfo={item}
                    onUse={() => {
                      thirdPartyMobx.checkCoupon({ ...item })
                    }}
                  />
                </div>
              ))
            }
          </div>
        </div>
      </IonContent>
      {hasCoupon && (
        <IonFooter>
          <div className='footer-btn' onClick={handleBack}>{i18n.t('common.confirm')}</div>
        </IonFooter>
      )}
    </IonPage>
  )
}

export default observer(ThirdCoupon)
